/** Grymwyrd Русский текст для общего макета (TopNav + Footer). */
export const layoutRu = {
  'layout.nav.veil': 'Завеса',
  'layout.nav.encyclopedia': 'Энциклопедия',
  'layout.nav.world': 'Мир',
  'layout.nav.play': 'Играть',
  'layout.nav.books': 'Книги & Правила',
  'layout.nav.community': 'Сообщество',
  'layout.nav.homeAria': 'Главная {world}',
  'layout.nav.search': 'Искать в энциклопедии',
  'layout.nav.unmute': 'Включить звук окружения',
  'layout.nav.mute': 'Отключить звук окружения',
  'layout.nav.coinBalance': 'Баланс монет',
  'layout.nav.signedInAs': 'Вы вошли как {name}',
  'layout.nav.enter': 'Войти в {world}',
  'layout.nav.toggleMenu': 'Открыть меню',
  'layout.nav.dashboard': 'Мой {world} ({name})',
  'layout.nav.signOut': 'Выйти',

  'layout.footer.hideLinks': 'Скрыть ссылки сайта',
  'layout.footer.showLinks': 'Ссылки и юридическая информация',
  'layout.footer.tagline': 'Живой мир ужаса-фэнтези, где ваша легенда становится канонической.',
  'layout.footer.explore': 'Исследовать',
  'layout.footer.legal': 'Юридическая информация',
  'layout.footer.accessibility': 'Доступность',
  'layout.footer.encyclopedia': 'Энциклопедия',
  'layout.footer.world': 'Мир',
  'layout.footer.playVtt': 'Играть (VTT)',
  'layout.footer.books': 'Книги & Правила',
  'layout.footer.terms': 'Условия использования',
  'layout.footer.privacy': 'Политика конфиденциальности',
  'layout.footer.canonRelease': 'Разрешение на публикацию канонических материалов',
  'layout.footer.aiPolicy': 'Политика в отношении ИИ',
  'layout.footer.cookies': 'Параметры файлов cookie',
  'layout.footer.copyright': '© 2026 GameCodex',
}
